import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  TextField,
  Chip
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FadeLoader } from "react-spinners";
import { FaPlus, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import SubscripationPlanVeiwController from "../../redux/actions/SubscripationPlanApiAction";

function AddPlans({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addPlans, updatePlans} = SubscripationPlanVeiwController();
  const isEdit = Boolean(initialData?.id);
  const { isLoading } = useSelector((state) => state.subscripation);

  const [initialValues, setInitialValues] = useState({
    name: "",
    price_per_employee: "",
    duration_days: 30,
    features: "",
    description: ""
  });

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        name: initialData.name || "",
        price_per_employee: initialData.price_per_employee || "",
        duration_days: initialData.duration_days || 30,
        features: initialData.features || "",
        description: initialData.description || ""
      });
    } else if (show) {
      setInitialValues({
        name: "",
        price_per_employee: "",
        duration_days: 30,
        features: "",
        description: ""
      });
    }
  }, [show, initialData]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updatePlans(initialData.id, values)
      : addPlans(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting plan:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        {isEdit ? "Edit Subscription Plan" : "Add Subscription Plan"}
        <IconButton onClick={handleClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
          {({ values, handleChange }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Plan Name"
                    name="name"
                    value={values.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Price per Employee (₹)"
                    name="price_per_employee"
                    type="number"
                    value={values.price_per_employee}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Duration (Days)"
                    name="duration_days"
                    type="number"
                    value={values.duration_days}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Features (comma separated)"
                    name="features"
                    value={values.features}
                    onChange={handleChange}
                    placeholder="Core HR & ESS, Attendance & Leave, Email support"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Description"
                    name="description"
                    value={values.description}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} textAlign="right">
                  <Button variant="outlined" onClick={handleClose} sx={{ mr: 2 }}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" color="primary">
                    {isEdit ? "Update" : "Submit"}
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {isLoading && (
          <div style={{
            position: "fixed", top: 0, left: 0, height: "100vh", width: "100vw",
            display: "flex", justifyContent: "center", alignItems: "center",
            background: "rgba(255, 255, 255, 0.6)", zIndex: 9999
          }}>
            <FadeLoader loading={true} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AddPlans;
